export default __webpack_public_path__ + "static/media/MOCK_DATA.f7f0b0fb.csv";